export type Currency =
  | "AUD"
  | "NZD"
  | "USD"
  | "GBP"
  | "EUR"
  | "IDR"
  | "JPY"
  | "RMB"
  | "SGD";

export const currencySymbolLookup: Record<Currency, string> = {
  AUD: "$",
  NZD: "$",
  USD: "$",
  GBP: "£",
  EUR: "€",
  IDR: "Rp",
  JPY: "¥",
  RMB: "¥",
  SGD: "S$",
};

export type Denomination =
  | "Single"
  | "Thousands"
  | "Millions"
  | "Billions"
  | "Trillions";

export const denominationLookup: Record<Denomination, string> = {
  Single: "",
  Thousands: "000's",
  Millions: "M",
  Billions: "BN",
  Trillions: "TN",
};
